module.exports = __webpack_public_path__ + "img/06.3e9c62b9.png";